import { ProductSetReference } from '../services/product/product-data'

/**
 * Determines if a product set is a fixed product set.
 * A fixed product set has all groups with at most 1 globalArticleCode.
 * Returns false (mix and match) if at least 1 group has more than 1 code.
 */
export const isFixedProductSet = (
  productSetReferences: Array<ProductSetReference> | undefined
): boolean => {
  if (!productSetReferences || productSetReferences.length === 0) {
    return true
  }

  return !productSetReferences.some(
    (reference) => (reference.globalArticleCode?.length ?? 0) > 1
  )
}
